import {createSlice} from "@reduxjs/toolkit";

const initialAdminsState = {
  isLoading: true,
  data: [],
  notification: null
};

export const adminsSlice = createSlice({
  name: "admins",
  initialState: initialAdminsState,
  reducers: {
    // Admin Responses
    adminNotification: (state, action) => {
      state.notification = action.payload.notification;
    },

    // fetchAdmins
    adminsFetched: (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
    },

    // addAdmin
    adminCreated: (state, action) => {
      state.notification = {type: "success", message: "Admin Account Created Successful"};
      state.data.push(action.payload.data);
    },

    // updateAdmin
    adminUpdated: (state, action) => {
      state.notification = {type: "success", message: "Admin Account Updated Successful"};
      state.data = state.data.map(admin => {
        return admin.id === action.payload.data.id ? action.payload.data : admin;
      });
    },
    
    // deleteAdmin
    adminDeleted: (state, action) => {
      state.notification = {type: "success", message: "Admin Account Deleted Successful"};
      state.data = state.data.filter(el => el.id !== action.payload.id);
    }
  }
});
